import {
    DOCUMENT_EXT_BMP,
    DOCUMENT_EXT_JPEG,
    DOCUMENT_EXT_JPG,
    DOCUMENT_EXT_PNG,
    DOCUMENT_EXT_TIFF,
} from './document-file.constants';
import { pickDocumentExtension } from './document-file-extension.util';

export const DOCUMENT_IMAGE_EXTENSION_PARTS = [
    pickDocumentExtension(DOCUMENT_EXT_JPG),
    pickDocumentExtension(DOCUMENT_EXT_JPEG),
    pickDocumentExtension(DOCUMENT_EXT_PNG),
    pickDocumentExtension(DOCUMENT_EXT_TIFF),
    pickDocumentExtension(DOCUMENT_EXT_BMP),
] as const;

export const DOCUMENT_IMAGE_FILE_EXTENSIONS: readonly string[] = [
    ...DOCUMENT_IMAGE_EXTENSION_PARTS,
];

export const DOCUMENT_IMAGE_FILE_ACCEPT =
    DOCUMENT_IMAGE_FILE_EXTENSIONS.join(',');

const EXTENSION_TO_MIME = {
    [DOCUMENT_EXT_JPG]: 'image/jpeg',
    [DOCUMENT_EXT_JPEG]: 'image/jpeg',
    [DOCUMENT_EXT_PNG]: 'image/png',
    [DOCUMENT_EXT_TIFF]: 'image/tiff',
    [DOCUMENT_EXT_BMP]: 'image/bmp',
} as const satisfies Record<
    (typeof DOCUMENT_IMAGE_EXTENSION_PARTS)[number],
    string
>;

export const DOCUMENT_IMAGE_MIME_ACCEPT = DOCUMENT_IMAGE_EXTENSION_PARTS.map(
    ext => EXTENSION_TO_MIME[ext]
).join(',');
